import { useState } from 'react'
import { VscChevronDown, VscChevronRight, VscFolder, VscFolderOpened, VscFile } from "react-icons/vsc";
import { useNavigate, useLocation } from 'react-router-dom'

import './homeTap.scss'

function HomeTap() {
  const [openTab, setOpenTab] = useState<{[number: number]: boolean }>({ 0: true })
  const [openFolders, setOpenFolders] = useState<{[key: string]: boolean}>({ 'pages': true })
  const navigate = useNavigate()
  const location = useLocation()

  const openTap = (value: number) => {
    const isActive = openTab[value]
    const newTapList = {...openTab, [value]: !isActive }
    setOpenTab(newTapList)
  }

  const toggleFolder = (folderName: string) => {
    setOpenFolders(prev => ({ ...prev, [folderName]: !prev[folderName] }))
  }

  const handlePageClick = (path: string) => {
    navigate(path)
  }

  const isActivePage = (path: string) => {
    return location.pathname === path
  }

  const renderFileTree = () => {
    const structure = {
      components: [
        'button',
        'chip',
        'explorer',
        'footer',
        'historyCard',
        'leftNav',
        'projectCard',
        'tapbar',
        'topNavbar'
      ],
      pages: [
        { name: 'home.tsx', path: '/' },
        { name: 'projects.tsx', path: '/projects' },
        { name: 'gallery.tsx', path: '/gallery' },
        { name: 'aboutme.tsx', path: '/aboutme' },
        { name: 'contact.tsx', path: '/contact' }
      ],
      theme: [
        'theme.scss',
        'color.scss'
      ],
      imgs: [
        'logo.png',
        'dwain.jpg',
        'death-star_plans.png',
        'error.png',
        'GTA-VI_map.jpg'
      ],
      root: [
        'config.tsx',
        'index.tsx',
        { name: 'README.md', path: '/readme' }
      ]
    }

    return (
      <div className='fileTree'>
        {/* Components Folder */}
        <div className='fileTree-folder' onClick={() => toggleFolder('components')}>
          <div className='folder-icon'>
            {openFolders['components'] ? <VscFolderOpened /> : <VscFolder />}
          </div>
          <div className='folder-name'>components</div>
        </div>
        {openFolders['components'] && (
          <div className='fileTree-files'>
            {structure.components.map(comp => (
              <div key={comp} className='file-item file-item-disabled'>
                <div className='folder-icon-small'>
                  <VscFolder />
                </div>
                <div className='file-name'>{comp}</div>
              </div>
            ))}
          </div>
        )}

        {/* Imgs Folder */}
        <div className='fileTree-folder' onClick={() => toggleFolder('imgs')}>
          <div className='folder-icon'>
            {openFolders['imgs'] ? <VscFolderOpened /> : <VscFolder />}
          </div>
          <div className='folder-name'>imgs</div>
        </div>
        {openFolders['imgs'] && (
          <div className='fileTree-files'>
            {structure.imgs.map(img => (
              <div key={img} className='file-item file-item-disabled'>
                <div className='file-icon'>
                  <VscFile />
                </div>
                <div className='file-name'>{img}</div>
              </div>
            ))}
          </div>
        )}

        {/* Pages Folder */}
        <div className='fileTree-folder' onClick={() => toggleFolder('pages')}>
          <div className='folder-icon'>
            {openFolders['pages'] ? <VscFolderOpened /> : <VscFolder />}
          </div>
          <div className='folder-name'>pages</div>
        </div>
        {openFolders['pages'] && (
          <div className='fileTree-files'>
            {structure.pages.map(page => (
              <div
                key={page.path}
                className={`file-item ${isActivePage(page.path) ? 'file-item-active' : ''}`}
                onClick={() => handlePageClick(page.path)}
              >
                <div className='file-icon'>
                  <VscFile />
                </div>
                <div className='file-name'>{page.name}</div>
              </div>
            ))}
          </div>
        )}

        {/* Theme Folder */}
        <div className='fileTree-folder' onClick={() => toggleFolder('theme')}>
          <div className='folder-icon'>
            {openFolders['theme'] ? <VscFolderOpened /> : <VscFolder />}
          </div>
          <div className='folder-name'>theme</div>
        </div>
        {openFolders['theme'] && (
          <div className='fileTree-files'>
            {structure.theme.map(file => (
              <div key={file} className='file-item file-item-disabled'>
                <div className='file-icon'>
                  <VscFile />
                </div>
                <div className='file-name'>{file}</div>
              </div>
            ))}
          </div>
        )}

        {/* Root Files */}
        {structure.root.map((file) => {
          const isFileObject = typeof file === 'object' && 'name' in file
          const fileName = isFileObject ? file.name : file
          const filePath = isFileObject ? file.path : null
          const isClickable = filePath !== null
          const isActive = isClickable && isActivePage(filePath)

          return (
            <div
              key={fileName}
              className={`file-item ${isClickable ? '' : 'file-item-disabled'} ${isActive ? 'file-item-active' : ''} file-item-root`}
              onClick={() => isClickable && handlePageClick(filePath)}
            >
              <div className='file-icon'>
                <VscFile />
              </div>
              <div className='file-name'>{fileName}</div>
            </div>
          )
        })}
      </div>
    )
  }

  const renderTap = (config: Array<{ title: string, id: number, disabled?: boolean }>) => {
    return config.map(tap => {
      return (
        <div key={tap.title + tap.id} className={`content-tapItem ${openTab[tap.id] && 'content-tapItemOpen'}`}>
          <div className={`tapItem-header ${!tap.disabled && 'tapItem-headerActive'}`} onClick={() => tap.disabled ? null : openTap(tap.id)}>
            <div className='header-icon'>
              {!openTab[tap.id] && <VscChevronRight />}
              {openTab[tap.id] && <VscChevronDown />}
            </div>
            <div className='header-title'>{tap.title}</div>
          </div>
          <div className={`tapItem-content ${openTab[tap.id] && 'tapItemOpen'}`}>
            {tap.id === 0 ? renderFileTree() : (
              <div style={{height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                under construction
              </div>
            )}
          </div>
        </div>
      )
    })
  }

  return (
    <div className='explorer-homeTap'>
      <div className='homeTap-header'>EXPLORER</div>
      <div className='homeTap-content'>

        {renderTap([
          { title: 'Dwain', id: 0 },
          { title: 'Outline', id: 1, disabled: true },
          { title: 'Timeline', id: 2, disabled: true },
          { title: 'Npm Scripts', id: 3, disabled: true }
        ])}

      </div>
    </div>
  )
}

export default HomeTap
